import { useState } from 'react';

import { IconRefreshCcw } from '@iwoca/icons';
import { Button, Flex, Modal, Stack, Text } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';

import { HelpModalContent } from '../../../../../../../../../navigation/helpModal/HelpModalContent';

export const IdCheckSmsSendError = ({
    isRetrying,
    onRetry
}: {
    isRetrying: boolean;
    onRetry: () => void;
}) => {
    const [isHelpModalOpen, setIsHelpModalOpen] = useState(false);

    return (
        <Stack gap="section">
            <Stack>
                <Text className="text-3xl font-bold">
                    <FormattedMessage
                        id="_.funding_requirements_v2.id_verification.send_error_title"
                        defaultMessage="Something went wrong..."
                    />
                </Text>
                <Text className="text-xl">
                    <FormattedMessage
                        id="_.funding_requirements_v2.id_verification.send_error"
                        defaultMessage="We were unable to send you an SMS. Please try again or contact us if the problem persists."
                    />
                </Text>
            </Stack>

            <Flex wrap="wrap" gap="tight">
                {/* ORION-113-GAP off-system: hand-styled outline pill button instead of an Orion Button variant; its inner layout and size stay as classes */}
                <button
                    type="button"
                    className="flex min-h-[52px] items-center gap-m rounded-full border border-primary-10 px-l text-l font-bold text-primary-10 hover:bg-structure-95"
                    onClick={() => setIsHelpModalOpen(true)}
                >
                    <FormattedMessage
                        id="_.funding_requirements_v2.id_verification.contact_us"
                        defaultMessage="Contact us"
                    />
                </button>
                <Button
                    variant="primary-rounded"
                    size="large"
                    type="button"
                    loading={isRetrying}
                    onClick={onRetry}
                >
                    <FormattedMessage
                        id="_.funding_requirements_v2.id_verification.try_again"
                        defaultMessage="Try again"
                    />
                    <IconRefreshCcw className="text-xl" />
                </Button>
            </Flex>

            <Modal
                headerBar
                isOpen={isHelpModalOpen}
                onClose={() => setIsHelpModalOpen(false)}
            >
                <HelpModalContent />
            </Modal>
        </Stack>
    );
};
